export default __webpack_public_path__ + "fonts/ic-union-pay.svg";